import React, { useEffect, useState } from "react";
import Loader from "../../../Components/Common/Loader";
import { Link } from "react-router-dom";
import { API } from "../../../api";
import moment from "moment";
import { useUserStore } from "../../../store/store";
import { RxLockClosed } from "react-icons/rx";
import { FiAlertCircle, FiBell } from "react-icons/fi";
import { getAccessToken } from "../../../api/auth";

const PrevInquiryListSection = (props) => {
  const [permission, user] = useUserStore((state) => [state.permission, state.user]);
  const { targetUser, targetSubdomain } = props;
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!targetUser) return;

    setLoading(true);
    const accessToken = getAccessToken();
    const _subdomain = targetSubdomain;

    API.get(`/inquiry/articles/?subdomain=${_subdomain}&phone_num=${targetUser}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.length === 0) return;
        setNotices(data);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setLoading(false));
  }, [targetSubdomain, targetUser]);

  if (loading) return <Loader loading={loading} />;
  if (!notices.length) return null;

  return (
    <div className="flex flex-col">
      {notices.map((item) => (
        <Link
          key={item.id}
          to={`/inquiry/detail/${item.id}`}
          className="group block border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors duration-200"
        >
          <div className="py-3 px-2 flex items-center justify-between">
            <div className="flex items-center gap-2 flex-1 min-w-0 pr-4">
              {/* Badges */}
              <div className="flex items-center gap-1 shrink-0">
                {!!permission?.permission && item.need_extra_info && (
                  <FiAlertCircle className="text-red-500" size={16} />
                )}

                {((!item.comment_count && moment(item.written_date).isAfter(moment().subtract(1, "days"))) ||
                  (item.latest_comment_date && moment(item.latest_comment_date).isAfter(moment().subtract(1, "days")))) && (
                    <span className="inline-block w-1.5 h-1.5 bg-red-500 rounded-full"></span>
                  )}

                {item.is_notice && <span className="text-xs font-bold text-red-500">[공지]</span>}

                {!!permission?.permission && !item.is_notice && !item.is_latest_comment_by_staff && (
                  <FiBell className="text-red-500" size={16} />
                )}

                {["2", "1"].includes(item.mode) && <RxLockClosed className="text-gray-400" size={14} />}
              </div>

              {/* Title */}
              <span className="text-sm text-gray-700 truncate font-medium group-hover:text-black">
                {item.title}
              </span>

              {/* Comment Count */}
              {item.comment_count > 0 ? (
                <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#F6475F] text-white text-[10px] font-bold shrink-0">
                  {item.comment_count}
                </span>
              ) : null}
            </div>

            {/* Date & User */}
            <div className="flex items-center gap-3 text-xs text-gray-400 shrink-0">
              <span className="hidden sm:inline">{moment(item.written_date).format("YYYY-MM-DD")}</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default PrevInquiryListSection;
